import constate from 'constate'
import { Currency } from '@/common/types/region-config.def.ts'
import { uniq } from 'lodash-es'
import { stringArrayToSelectOptions } from '@/utils/misc.ts'
import { CountryCurrencyMap } from '@/common/types/compensation.def.ts'

type TermSheetConfigProviderProps = {
  region: string
  candidateType: string
  isHiringManagerPrincipal: boolean
}
export const TermSheetCandidateType = {
  PM: 'PM',
  APM: 'Sub-PM/APM',
  Analyst: 'Analyst',
}
export const TermSheetCandidateTypeOptions = stringArrayToSelectOptions(Object.values(TermSheetCandidateType))

export const [TermSheetConfigProvider, useTermSheetConfig] = constate(({
  region,
  candidateType,
  isHiringManagerPrincipal,
}: TermSheetConfigProviderProps) => {
  const localCcy = CountryCurrencyMap[region]
  const bonusCcyOptions = candidateType === TermSheetCandidateType.PM
    ? [Currency.USD]
    : (isHiringManagerPrincipal && candidateType === TermSheetCandidateType.APM)
      ? [localCcy, Currency.USD]
      : [localCcy]

  return {
    region,
    candidateType,
    isHiringManagerPrincipal,
    usdOnly: [Currency.USD],
    baseSalaryCcyOptions: [localCcy],
    bonusCcyOptions: uniq(bonusCcyOptions) as Currency[],
    allCcyOptions: uniq([Currency.USD, localCcy]) as Currency[],
  }
})